import React, { Component } from 'react';
import Logo from './Logo';

import { Layout, Header, Content } from 'react-mdl';
import '../css/App.css';

class App extends Component {
  render() {
    // console.log('App render() this.props:', this.props)
    return (
      <div className="App">
        <Layout fixedHeader>
          <Header style={{backgroundColor: '#000', borderBottom: '5px solid #F88C00'}}>
            <Logo />
          </Header>
          <Content>
            {this.props.children}
          </Content>
        </Layout>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/